/**
 * Team V2 Repository - GraphQL Queries
 *
 * 7 query operations for Team primitive data access.
 * All queries use TEAM_FIELDS_FRAGMENT for consistency.
 *
 * Signatures match deploy/router/schemas/core.graphql exactly.
 * Backend resolves tenantId from auth context for most queries.
 */

import { gql } from '@apollo/client';
import { TEAM_FIELDS_FRAGMENT } from './fragments';

export const GET_TEAM = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query GetTeam($code: String!) {
    getTeam(code: $code) {
      ...TeamFields
    }
  }
`;

export const LIST_TEAMS = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query ListTeamsRepo($limit: Int) {
    listTeams(limit: $limit) {
      ...TeamFields
    }
  }
`;

export const LIST_TEAMS_BY_TYPE = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query ListTeamsByType($teamType: GqlTeamType!, $limit: Int) {
    listTeamsByType(teamType: $teamType, limit: $limit) {
      ...TeamFields
    }
  }
`;

export const LIST_CHILD_TEAMS = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query ListChildTeams($parentId: String!, $limit: Int) {
    listChildTeams(parentId: $parentId, limit: $limit) {
      ...TeamFields
    }
  }
`;

export const GET_TEAM_HIERARCHY = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query GetTeamHierarchy($code: String!) {
    getTeamHierarchy(code: $code) {
      ...TeamFields
    }
  }
`;

export const LIST_ACTIVE_TEAMS = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query ListActiveTeams($limit: Int) {
    listActiveTeams(limit: $limit) {
      ...TeamFields
    }
  }
`;

export const SEARCH_TEAMS = gql`
  ${TEAM_FIELDS_FRAGMENT}
  query SearchTeams($query: String!, $limit: Int) {
    searchTeams(query: $query, limit: $limit) {
      ...TeamFields
    }
  }
`;
